import { verifyPasswordAPI } from "@/apis/auth-api"
import { langStore } from "@/stores/lang-store"
import { myPageBundle } from "@/routes/my/my-page-const"
import PW_Input from "@/routes/my/_components/pw-input"
import { passwordChangeStore } from "@/routes/my/pw/change/pw-change-store"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import PW_Card from "../../_components/pw-card"
import PW_SubmitButton from "../../_components/pw_submit-button"

const PW_VerifyPage = () => {
  const navigate = useNavigate()
  const { lang } = langStore()
  const [currentPassword, setCurrentPassword] = useState("")
  const [visible, setVisible] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const bundle = myPageBundle.password

  const handleSubmit = async (event) => {
    event.preventDefault()

    try {
      setIsSubmitting(true)

      await verifyPasswordAPI({ current_password: currentPassword })

      passwordChangeStore.getState().setVerifiedPassword(currentPassword)
      setCurrentPassword("")
      navigate("/my/pw/change", { replace: true })
    } catch (error) {
      toast.error(error?.response?.data?.detail ?? bundle.failure[lang])
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <PW_Card title={bundle.verifyTitle[lang]} description={bundle.verifyDescription[lang]}>
      <form className="space-y-5" onSubmit={handleSubmit}>
        <PW_Input
          label={bundle.current[lang]}
          name="currentPassword"
          value={currentPassword}
          visible={visible}
          onChange={(event) => setCurrentPassword(event.target.value)}
          onToggle={() => setVisible((prev) => !prev)}
          autoComplete="current-password"
        />

        <PW_SubmitButton disabled={isSubmitting || !currentPassword}>
          {isSubmitting ? bundle.verifying[lang] : bundle.verifySubmit[lang]}
        </PW_SubmitButton>
      </form>
    </PW_Card>
  )
}

export default PW_VerifyPage
